import { AiOutlineLinkedin } from 'react-icons/ai'
import { VscGithub } from 'react-icons/vsc'
import { SiItchdotio } from 'react-icons/si'
import { BgImage25 } from '../styledComponents/backgroundStyled'
import { FooterStyled, H5HeadingStyled, ContainerFooter } from '../styledComponents/footerStyled'
import '../theme/core.css'
export default function FooterComp() {

    return (
        <>
            <div className="merg"></div>
            <BgImage25>
                <FooterStyled >
                    <H5HeadingStyled>© 2022, made with React by Damian Raymond Dowie </H5HeadingStyled>
                    <ContainerFooter>
                        <a href="https://www.linkedin.com/in/damian-dowie-504aaa114/" rel="noreferrer" target="_blank" style={{ textDecoration: "none" }}>
                            <AiOutlineLinkedin style={{ color: 'white', fontSize: '3rem' }} />
                        </a>
                        <a href="https://damiandowie.itch.io/" rel="noreferrer" target="_blank" style={{ textDecoration: "none" }}>
                            <SiItchdotio style={{ color: 'white', fontSize: '3rem' }} />
                        </a>
                        <a href="https://github.com/LegendDRD" rel="noreferrer" target="_blank" style={{ textDecoration: "none" }}>
                            <VscGithub style={{ color: 'white', fontSize: '3rem' }} />
                        </a>

                    </ContainerFooter>
                </FooterStyled>
            </BgImage25>
        </>
    );
}
